import axios from "axios";
let Base64 = require("js-base64").Base64;
let md5 = require("js-md5");
let model_status = true;
let nexts = 0;
import sha1 from "sha1";
// axios 配置

axios.defaults.baseURL = "https://admin.juniubang.com/api/v1";
// axios.defaults.baseURL = "https://convert.dop.360.cn";
axios.defaults.timeout = 50000;

axios.interceptors.request.use(
  config => {
    // var timestamp = Math.round(new Date().getTime() / 1000);
    config.headers = {
      // "Content-Type": "application/x-www-form-urlencoded",
      "X-Token-With": getToken()
    };
    // config.data = config.data.params;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
export default axios;
/**
 * get 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {

      })

  });
}
/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {

  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => { },
    );
  });
};


function getToken() {
  const appid = 'jnb1688';
  const secret = '123456';
  const version = 'api/v1';
  const timestamp = new Date().getTime();
  const sign = sha1(appid + 'APPID' + secret + 'SECRET' + timestamp);
  return sign + '.' + timestamp + '.' + version;
}



//////////////////
// WEBPACK FOOTER
// ./http.js
// module id = null
// module chunks = 